import React, { useCallback, useEffect, useState } from "react";
import {
  Alert,
  Button,
  FormFieldSet,
  Modal,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import UnapaidtimesheetdetailsModel from "./UnapaidtimesheetdetailsModel";
import common from "../../../../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { fetchTimesheetsPlacements } from "../../../../../../redux/slices/timesheets/timesheetApi";
import { empOtherPayementsTimeSheet } from "../../../../../../redux/slices/employee/employeeSlice";
import { showToastMessage } from "../../../../../../utils/toastUtil";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addOtherPaymentsStart } from "../../../../../../redux/slices/payroll/payrollSlice";

const PayOtherPaymentModal = ({
  open,
  onClose,
  onShowUnpaid,
  empOtherPayemntsSelectTimeSheets,
}) => {
  const { userData: loginUserData } = useLoginUser();
  // const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;

  const {
    getCutoffEndDateWithDayjs,
    convertToUSD,
    calculateBalances,
    generateTimeSheetsUpdatePayloads,
    updateTimeSheetData,
  } = common;
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
  } = useSelector((state) => state.employee);
  const dispatch = useDispatch();
  const [unPaidTimeSheet, setUnPaidTimeSheet] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const defaultValues = {
    project: "",
    totalTimeSheetValue: "",
    paidAmount: "",
    comments: "",
    paymentDate: "",
    ExchangeAmount: "",
    Exchangeamout2: "",
    attachment: "",
  };
  const { formData, errors, handleChange, setFormData, validateAllFields } =
    useFormHandler(defaultValues, {
      totalTimeSheetValue: { type: "text", required: true },
      project: { type: "text", required: true },
      paidAmount: { type: "text", required: true },
      pendingAmount: { type: "text", required: true },
      comments: { type: "text", required: true },
      paymentDate: { type: "date", required: true },
      // ExchangeAmount: { type: "text", required: true, number: true },
      // Exchangeamout2: { type: "text", required: true, number: true },
      // attachment: {
      //   type: "file",
      //   required: true,
      // },
    });
  const [showUnpaidModal, setShowUnpaidModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const accumulatedAmount =
    empOtherPayemntsSelectTimeSheets?.reduce((total, entry) => {
      console.log({ total, entry });
      return Number(
        Number(total) + (Number(entry?.totalTimeAmount) || 0),
      ).toFixed(2);
    }, 0) || 0;

  const handleSaveLogic = async () => {
    // onClose();
    // setShowAlert(false);
    try {
    const uiids = empOtherPayemntsSelectTimeSheets.map((data) => data.uiid);
    const payload = {
      employeeId: employeeProfileUiid,
      timesheetId: uiids,
      payDate: formData?.paymentDate,
      amounts: {
        total: formData?.totalTimeSheetValue,
        paid: formData?.paidAmount,
        pending: formData?.pendingAmount,
      },
      exchange: {
        amt: formData?.Exchangeamout2,
        rate: formData?.ExchangeAmount,
      },
      comments: formData?.comments,
      addedBy: loginUserUiid,
    };
    const submissionData = filterEmptyValues(payload);

    const cleanAttachments =
      Array.isArray(formData.attachment) && formData.attachment.length > 0
        ? formData.attachment
        : [];
    const onSuccessCallback = async () => {
      try {
        const calculateBalancesData = await calculateBalances(
          [...empOtherPayemntsSelectTimeSheets],
          Number(formData?.paidAmount),
        );
        const generateTimeSheetsUpdatePayloadsData =
          await generateTimeSheetsUpdatePayloads(calculateBalancesData);
        for (const data of generateTimeSheetsUpdatePayloadsData) {
          await updateTimeSheetData(data); // await here!
        }
        onClose();
        handleCloseModal();
        setShowAlert(false);
        setFormData(defaultValues);
      } catch (err) {
        console.error("Error updating timesheets:", err);
      }
    };
    if (cleanAttachments.length > 0) {
      dispatch(
        uploadStart({
          uploadType: "multiple",
          field: "doc",
          uiid: employeeProfileUiid,
          entity: "employees",
          category: "otherPayments",
          coll: "EmpOtherPay",
          doc: cleanAttachments,
          onSuccess: (fileData) => {
            const upateSubmissionData = {
              ...submissionData,
              attachments: fileData
                .filter((data) => data.key)
                .map((data) => data.key),
            };
            dispatch(
              addOtherPaymentsStart({
                coll: "EmpOtherPay",
                payload: upateSubmissionData,
                onSuccess: onSuccessCallback,
              }),
            );
          },
        }),
      );
    }
    else {
      dispatch(
        addOtherPaymentsStart({
          coll: "EmpOtherPay",
          payload: submissionData,
          onSuccess: onSuccessCallback,
        })
      );
    }
    }catch(e) {
      console.error("error in handleSaveLogic");
    }    
  };

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      setShowAlert(true);
    } else {
      showToastMessage("error", "COMMON.REQUIRED_FIELDS");
    }
  };
  const handleCallTimeSheet = async () => {
    if (!employeeProfileUiid) return;
    const payload = {
      filters: {
        employeeId: {
          type: "NONE",
          value: employeeProfileUiid,
        },
        status: {
          type: "NONE",
          value: 6,
        },
        paid: {
          type: "NONE",
          value: false,
        },
        "period.to": {
          type: "LTE",
          value: getCutoffEndDateWithDayjs().toISOString(),
        },
      },
      ref: "Client Placement Invoice",
      incl: ["businessName", "jobInfo.jobTitle payments timesheetDetails", "invoiceNum amounts status"],
      sort: {
        "period.from": -1
      }
    };
    try {
      const response = await fetchTimesheetsPlacements(payload);
      const data = response?.data?.data || [];
      const modifiedData = data.map((item) => ({
        ...item,
        id: item._id, // adding `id` field based on `_id`
        isInvoiceNotPaid: item?.invoiceId?.every(inv => inv.amounts.invoiced !== inv.amounts.received)
      }));

      setUnPaidTimeSheet(modifiedData);
    } catch (err) {
      console.error("Failed to fetch unpaid timesheets:", err);
      setUnPaidTimeSheet([]); // Optional: clear on error
    }
  };
  useEffect(() => {
    dispatch(empOtherPayementsTimeSheet([]));
  }, []);
  useEffect(() => {
    if (empOtherPayemntsSelectTimeSheets.length > 0) {
      handleChange(
        "totalTimeSheetValue",
        `${Number(accumulatedAmount)?.toFixed(2)}`,
      );
      const businessNames = empOtherPayemntsSelectTimeSheets.map(
        (data) => data.clientId?.businessName,
      );
      const businessNamesString = businessNames.join(",");
      handleChange("project", businessNamesString);
    } else {
      handleChange("totalTimeSheetValue", "");
    }
  }, [empOtherPayemntsSelectTimeSheets]);
  // const handleConvertINRToUSD = () => {
  //   const inrAmount = parseFloat(formData.Exchangeamout2);
  //   const exchangeRate = parseFloat(formData.ExchangeAmount); // e.g., 1 USD = 83.25 INR

  //   if (isNaN(inrAmount) || isNaN(exchangeRate) || exchangeRate === 0) {
  //     console.error("Invalid input");
  //     return;
  //   }

  //   const usdAmount = convertToUSD(inrAmount, exchangeRate);
  //   console.log(`USD Amount: $${usdAmount}`);
  //   handleChange("paidAmount", `${usdAmount}`);
  // };
  const handleConvertINRToUSD = useCallback(() => {
    const exchangeRate = Number(formData?.ExchangeAmount || 0); // e.g., 1 USD = 83.25 INR
    const inrAmount = Number(formData?.Exchangeamout2 || 0);

    if (isNaN(inrAmount) || isNaN(exchangeRate) || exchangeRate === 0) {
      console.error("Invalid input");
      return;
    }

    // const usdAmount = convertToUSD(inrAmount, exchangeRate);
    handleChange("paidAmount", `${(exchangeRate / inrAmount).toFixed(2)}`);
  }, [formData?.Exchangeamout2, formData?.ExchangeAmount]);
  useEffect(() => {
    const paidAmount = Number(formData?.paidAmount || 0);
    const totalTimeSheetValue = Number(formData?.totalTimeSheetValue || 0);
    if (paidAmount && totalTimeSheetValue) {
      const pendingAmount = totalTimeSheetValue - paidAmount;
      handleChange("pendingAmount", `${pendingAmount.toFixed(2)}`);
    }
  }, [formData.totalTimeSheetValue, formData.paidAmount]);
  const handleCloseModal = () => {
    setSelectedRows([]);
    dispatch(empOtherPayementsTimeSheet([]));
    onClose();
    setFormData(defaultValues);
  };
  return (
    <>
      <Modal
        isOpen={open}
        onClose={handleCloseModal}
        title="PAY OTHER PAYMENT"
        width="max-w-6xl"
      >
        <div>
          <div className="flex">
            <div className="text-sm font-semibold">
              Total Pending Amount
              <br />
              <span className="text-lg text-black-600 font-bold">
                ${accumulatedAmount}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-6 max-w-7xl mt-2">
            <div>
              <Button
                // type="icon"
                // icon={"eye"}
                // title="Show Unpaid Timesheets"
                title="All Unpaid timesheets."
                size="md"
                // variant="outlined"
                // icon="visibility"
                // icon="eye_tracking"
                onClick={() => {
                  setShowUnpaidModal(true);
                  handleCallTimeSheet();
                  //   setActiveTab((prev)=>prev+2 )
                }}
                className="w-full h-10 mt-5"
              />
            </div>
            <FormFieldSet
              type="text"
              title="Total TimeSheet Value"
              placeholder="Enter Total TimeSheet Value"
              value={formData.totalTimeSheetValue}
              onChange={(value) => handleChange("totalTimeSheetValue", value)}
              error={errors.totalTimeSheetValue}
              disabled={true}
            />
            <FormFieldSet
              type="text"
              title="Project"
              placeholder="Enter Project"
              value={formData.project}
              onChange={(value) => handleChange("project", value)}
              error={errors.project}
            />
            <div className="hidden xl:block" />

            <FormFieldSet
              type="text"
              title="Paid Amount"
              placeholder="Enter Paid Amount"
              value={formData.paidAmount}
              onChange={(value) => handleChange("paidAmount", value)}
              error={errors.paidAmount}
            // disabled
            />

            <div className="col-span-1 sm:col-span-2 flex gap-1 items-end">
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  title="Exchange Amount"
                  placeholder="Enter Rate"
                  value={formData.ExchangeAmount}
                  onChange={(value) => handleChange("ExchangeAmount", value)}
                  error={errors.ExchangeAmount}
                />
              </div>
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  title=" "
                  placeholder="Amount"
                  value={formData.Exchangeamout2}
                  onChange={(value) => handleChange("Exchangeamout2", value)}
                  error={errors.Exchangeamout2}
                />
              </div>
            </div>

            <div className="mt-5">
              <Button
                title="Auto Adjust"
                size="sm"
                onClick={handleConvertINRToUSD}
                disabled={!formData.ExchangeAmount || !formData.Exchangeamout2}
              />
            </div>
            <div className="hidden xl:block" />
            <FormFieldSet
              type="text"
              title="Pending Amount"
              placeholder="Enter Pending Amount"
              value={formData.pendingAmount}
              onChange={(value) => handleChange("pendingAmount", value)}
              error={errors.pendingAmount}
              disabled={true}
            />
            <FormFieldSet
              type="datepicker"
              title="Payment Date"
              placeholder="MM/DD/YYYY"
              value={formData.paymentDate}
              onChange={(value) => handleChange("paymentDate", value)}
              error={errors.paymentDate}
              showDropdown={false}
            />
            <div className="hidden xl:block" />
            <div className="hidden xl:block" />

            <FormFieldSet
              type="file"
              title="Attachment"
              placeholder="Choose File"
              value={formData.attachment}
              onChange={(value) => handleChange("attachment", value)}
              error={errors.attachment}
            />
            {/* //grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 */}
            <div className="col-span-2 lg:col-span-3 xl:col-span-2 flex flex-col gap-4">
              <FormFieldSet
                type="textArea"
                title="Comments"
                placeholder="Enter Comments"
                value={formData.comments}
                onChange={(value) => handleChange("comments", value)}
                error={errors.comments}
              />
            </div>
          </div>

          <div className="flex gap-3 justify-end mt-6">
            <Button
              title="Cancel"
              variant="outlined"
              onClick={handleCloseModal}
            />
            <Button title="Update" onClick={handleSave} />
          </div>
        </div>
      </Modal>

      <UnapaidtimesheetdetailsModel
        open={showUnpaidModal}
        onClose={() => setShowUnpaidModal(false)}
        unPaidTimeSheet={unPaidTimeSheet}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        empOtherPayemntsSelectTimeSheets={empOtherPayemntsSelectTimeSheets}
      />

      <Alert
        isOpen={showAlert}
        onClose={() => setShowAlert(false)}
        title="This transaction cannot be retrieved"
        cancelButton={{
          show: true,
          title: "No",
          onClick: () => setShowAlert(false),
        }}
        acceptButton={{
          show: true,
          title: "Yes",
          onClick: handleSaveLogic,
        }}
      />
    </>
  );
};

export default PayOtherPaymentModal;
